import React, { RefAttributes, forwardRef } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { colors, shadows } from '../../../utils/theme';
import { useIsInSideTabContentContainer } from '../TabView';

export type PaperOwnProps = {
    style?: StyleProp<ViewStyle>;
    children: React.ReactNode | React.ReactNode[];
    testID?: string;
};

export type PaperProps = PaperOwnProps & RefAttributes<View>;

const Paper: React.FC<PaperProps> = forwardRef((props, ref) => {
    const isInSideTabContentContainer = useIsInSideTabContentContainer();

    return (
        <View
            ref={ref}
            style={[
                {
                    width: '100%',
                    backgroundColor: colors['White'],
                    borderRadius: 5,
                    borderWidth: 1,
                    borderColor: colors['Paper-Border'],
                    ...(isInSideTabContentContainer
                        ? {
                              borderWidth: 1,
                              borderColor: colors['Paper-Border'],
                          }
                        : shadows.default),
                },
                props.style,
            ]}
            testID={props.testID}
        >
            {props.children}
        </View>
    );
});

export default React.memo(Paper);
